import type { ReactNode } from "react";
import { cn } from "../lib/cn";
import { AccountBar } from "./account-bar";
import { LogoIntro } from "./logo-intro";
import { Card } from "./ui/card";
import { Wordmark } from "./wordmark";

// Rahmen für Seiten außerhalb eines Mandanten (Start, Login-Rücksprung,
// Mandantenwahl, Onboarding, Einladung): Logo oben, eine Karte in der Mitte.
//
// Immer im dunklen Thema (Entscheidung 41): data-theme="dark" schaltet die
// semantischen Tokens (bg-page, bg-card, text-ink …) nur innerhalb dieses
// Elements auf die dunklen Werte um; der Rest der App bleibt hell.
//
// intro=true (nur Startseite): animiertes Logo und verzögert eingeblendete Karte.
// account=true (Seiten nach dem Login): Konto und „Abmelden“ unter der Karte.
export function CenteredPage({
  children,
  wide = false,
  intro = false,
  account = false,
}: {
  children: ReactNode;
  wide?: boolean;
  intro?: boolean;
  account?: boolean;
}) {
  return (
    <main
      data-theme="dark"
      className="flex min-h-screen flex-col items-center justify-center gap-10 bg-page px-4 py-12 text-ink"
    >
      {intro ? <LogoIntro className="w-44 sm:w-56" /> : <Wordmark tone="negativ" size="lg" />}
      <Card
        className={cn(
          "w-full px-6 py-7 sm:px-7 sm:py-8",
          wide ? "max-w-lg" : "max-w-sm",
          intro && "intro-card",
        )}
      >
        {children}
      </Card>
      {account && <AccountBar wide={wide} />}
    </main>
  );
}
